<template>
<div class="p_interlude">
  <div class="top_container ratio_header" v-bind:style="{ 'padding-top': topContainerPaddingTop + 'px' }">
    <img src="@/assets/img/premium/interlude_close.svg" @click="tapClose()" />
  </div>
  <div class="container ratio_title">
    <div class="interlude_icon">
      <img src="@/assets/img/premium/interlude_icon.svg" />
    </div>
    <div class="title_wapper">
      <img class="arrow_left" src="@/assets/img/premium/interlude_sub_title_arrow_left.png" />
      <p class="sub_title">香の川製麺プレミアムラウンジ</p>
      <img class="arrow_right" src="@/assets/img/premium/interlude_sub_title_arrow_right.png" />
    </div>
  </div>
  <div class="container ratio_message">
    <p class="message">
      いつも香の川製麺アプリを <br />ご利用いただき
      <br />ありがとうございます。 <br />ここは、
      <br />香の川製麺プレミアムラウンジ会員のみ
      <br />入室できるエリアになります。
    </p>
  </div>
  <div class="container ratio_btn">
    <div @click="toLounge">
      <div>
        <img class="interlude_btn" src="@/assets/img/premium/interlude_btn2.png" @click="tapPremium()" />
      </div>
    </div>
    <router-link to="/faq/premium?showHeader=false" @click.native="() => { trapTrackEvent(2) }">
      <div>
        <img class="interlude_btn" src="@/assets/img/premium/interlude_btn.png" @click="tapFaqPremiumLounge()" />
      </div>
    </router-link>
  </div>
</div>
</template>

<script>
import {
  mapActions
} from 'vuex'
import { FactoryTrack } from '@/constant/firebase'

export default {
  name: 'PremiumInterlude',
  data: function () {
    return {
      topContainerPaddingTop: 30
    }
  },
  async created() {
    // ここでタイトルに空文字を入れないと２回目のインタールードからのFAQPremiumへの画面遷移でタイトルがURLになる
    document.title = ''
    this.getHeaderPaddingTop()
    this.actionHideHeader()
  },
  methods: {
    ...mapActions('Native', [
      'actionCloseInterlude',
      'actionShowHeader',
      'actionHideHeader',
      'actionRequestPaddingTop',
      'actionVer6_3'
    ]),
    ...mapActions('Analytics', ['trackEvent']),
    trapTrackEvent(id) {
      switch (id) {
        case 1:
          this.trackEvent(FactoryTrack.createPremiumCoupon())
          break
        case 2:
          this.trackEvent(FactoryTrack.createFAQPremium())
          break
      }
    },
    tapPremium: function () {
      console.log('tapPremium')
    },
    tapFaqPremiumLounge: function () {
      console.log('tapAboutPremium')
      this.actionShowHeader()
    },
    tapClose: function () {
      this.trackEvent(FactoryTrack.createClose('プレミアムラウンジ'))
      console.log('tapClose')
      this.actionCloseInterlude()
    },
    getHeaderPaddingTop() {
      // iPhone
      if (navigator.userAgent.indexOf('iPhone') > 0) {
        window.receivedTopPadding = payload => {
          const json = JSON.parse(payload)
          this.topContainerPaddingTop = json.paddingTop
        }
        this.actionRequestPaddingTop('premiuminterlude')
      }
    },
    async toLounge() {
      this.trapTrackEvent(1)
      const v63 = await this.actionVer6_3()
      console.log(v63)
      await this.$router.push(`/premium/${v63 === 0 ? 'lounge' : 'coupon'}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.ratio_header {
  height: 11%;
}

.ratio_title {
  height: 29%;
}

.ratio_message {
  height: 35%;
  padding-top: 20px;
  padding-bottom: 10px;
}

.ratio_btn {
  height: 25%;
}

.p_interlude {
  background-image: url('~@/assets/img/premium/interlude_bg.png');
  width: 100%;
  height: 100%;
  background-size: cover;
  z-index: 1;
}

.top_container {
  text-align: right;
  padding-right: 30px;
}

.container {
  text-align: center;
  margin: 0 auto;
}

.interlude_title {
  width: 80%;
  height: auto;
}

.interlude_btn {
  width: 80%;
  height: auto;
  padding-bottom: 15px;
}

.arrow_left {
  margin-right: 7px;
}

.arrow_right {
  margin-left: 7px;
}

.title_wapper {
  height: 20px;
  display: flex;
  justify-content: center;

  img {
    height: 100%;
  }

  .sub_title {
    color: #c0a422;
    font-size: 3.5vw;
    display: inline-block;
    font-weight: bold;
  }
}

.message {
  color: white;
  font-weight: bold;
  font-size: 15px;
}

.interlude_icon {
  padding-bottom: 10px;
}
</style>
